var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 17.8933V22.608C24.0002 22.9456 23.8723 23.2706 23.6421 23.5176C23.412 23.7646 23.0967 23.915 22.76 23.9387C22.1773 23.9787 21.7013 24 21.3333 24C9.55067 24 0 14.4493 0 2.66667C0 2.29867 0.02 1.82267 0.0613333 1.24C0.0849632 0.903259 0.235442 0.588014 0.482405 0.357878C0.729368 0.127742 1.05443 -0.000152577 1.392 3.42106e-07H6.10667C6.27205 -0.000167113 6.4316 0.0611454 6.55431 0.172027C6.67701 0.282909 6.75413 0.435444 6.77067 0.6C6.80133 0.906667 6.82933 1.15067 6.856 1.336C7.12098 3.18523 7.664 4.98378 8.46667 6.67067C8.59333 6.93733 8.51067 7.256 8.27067 7.42667L5.39333 9.48267C7.1526 13.5819 10.4194 16.8487 14.5187 18.608L16.572 15.736C16.6559 15.6187 16.7784 15.5345 16.918 15.4982C17.0576 15.4619 17.2055 15.4757 17.336 15.5373C19.0227 16.3386 20.8208 16.8802 22.6693 17.144C22.8547 17.1707 23.0987 17.1987 23.4027 17.2293C23.567 17.2462 23.7192 17.3234 23.8298 17.4461C23.9404 17.5688 24.0002 17.7282 24 17.8933Z",
    fill: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contact-icon.d67cb54258e6246a7bd354193a6fe889.svg";
export { ForwardRef as ReactComponent };